
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/[path]",
      function () {
        return require("private-next-pages/content/[path].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content/[path]"])
      });
    }
  